"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import Lenis from "lenis";

export function SmoothScroll() {
  const pathname = usePathname();

  useEffect(() => {
    // Disable smooth scroll on the landing page - native scroll feels snappier
    const isLanding = pathname === "/" || pathname === "";
    if (isLanding) {
      return;
    }

    // Respect prefers-reduced-motion: skip smooth scroll entirely
    const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (motionQuery.matches) {
      return;
    }

    const isDashboard = pathname?.startsWith("/dashboard");
    const lenis = new Lenis({
      duration: isDashboard ? 0.55 : 1.1,
      lerp: isDashboard ? 0.16 : 0.1,
      smoothWheel: true,
      wheelMultiplier: isDashboard ? 1.1 : 1,

      gestureOrientation: "vertical",
    });

    let rafId = 0;
    const raf = (time: number) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // If the user changes their preference mid-session, destroy Lenis
    const onChange = () => {
      if (motionQuery.matches) {
        lenis.destroy();
        cancelAnimationFrame(rafId);
      }
    };
    motionQuery.addEventListener("change", onChange);

    return () => {
      motionQuery.removeEventListener("change", onChange);
      lenis.destroy();
      cancelAnimationFrame(rafId);
    };
  }, [pathname]);

  return null;
}
